import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { Toaster } from "sonner";
import { InstagramLogo } from "@phosphor-icons/react";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import ProtectedRoute from "./components/ProtectedRoute";
import InstallPrompt from "./components/InstallPrompt";
import Landing from "./pages/Landing";
import Classes from "./pages/Classes";
import ClassDetail from "./pages/ClassDetail";
import Library from "./pages/Library";
import Subscribe from "./pages/Subscribe";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Admin from "./pages/Admin";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";

const IG_URL = "https://instagram.com/trainwithlucy";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App min-h-screen flex flex-col">
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/classes" element={<Classes />} />
              <Route path="/classes/:id" element={<ClassDetail />} />
              <Route path="/subscribe" element={<Subscribe />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/library" element={<ProtectedRoute><Library /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
            </Routes>
          </main>
          <footer className="border-t border-white/10 mt-12" data-testid="footer">
            <div className="max-w-7xl mx-auto px-6 py-10 grid sm:grid-cols-3 gap-6 items-center">
              <div className="label-overline text-zinc-500">© Train With Lucy — Train With Intent</div>
              <div className="flex items-center justify-center">
                <a href={IG_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 label-overline text-zinc-300 hover:text-[#D4A574] border border-white/15 px-4 py-2" data-testid="footer-instagram">
                  <InstagramLogo weight="duotone" size={18} /> @trainwithlucy
                </a>
              </div>
              <div className="flex items-center justify-end gap-5 label-overline text-zinc-500">
                <Link to="/privacy" className="hover:text-white" data-testid="footer-privacy">Privacy</Link>
                <Link to="/terms" className="hover:text-white" data-testid="footer-terms">Terms</Link>
              </div>
            </div>
          </footer>
          <InstallPrompt />
          <Toaster theme="dark" position="top-right" toastOptions={{ style: { background: "#7F7164", border: "1px solid rgba(255,255,255,0.1)", color: "#fff" } }} />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}
